export const sizeClasses = {
  s: 'w-full max-w-[900px]! xl:w-[30%] 3xl:max-w-[1000px]!',
  m: 'w-full max-w-[900px]! lg:max-w-none xl:w-[50%] xl:max-w-[900px]! 3xl:w-[40%] 3xl:max-w-[1000px]!',
  l: 'w-full max-w-[900px]! lg:w-[90%] xl:w-[60%] xl:max-w-[1000px]! 3xl:w-[50%] 3xl:max-w-[1200px]!'
} as const;

export type OverlaySize = keyof typeof sizeClasses;
